const fetchAs = require("./fetchAs");
const slugify = require("./slugify");
const mime = require("mime-types");

module.exports = async function fetchMediaDownload(uuid, dispatch) {
	const media_response = await fetchAs({ endpoint: `media/image/${uuid}`, dispatch });
	if (media_response) {
		const media = media_response.data ? media_response.data : null;
		if (media) {
			let mid = media.attributes.drupal_internal__mid;
			let media_title =
				media.attributes.name && media.attributes.name.includes(".")
					? media.attributes.name.split(".")[0]
					: media.attributes.name;
			let file_name = media_title ? slugify(media_title) : `file-${uuid}`;
			let filemime = media.attributes.field_filemime;
			if (!filemime) {
				let file_field_name = Object.keys(media.relationships).find((key) =>
					key.includes("field_")
				);
				if (file_field_name) {
					let file_rel = media.relationships[file_field_name];
					if (file_rel && file_rel.data && file_rel.data.id) {
						const file_response = await fetchAs({
							endpoint: `file/file/${file_rel.data.id}`,
							dispatch,
						});
						if (file_response) {
							const file = file_response.data ? file_response.data : null;
							if (file && file.attributes && file.attributes.filemime) {
								filemime = file.attributes.filemime;
							}
						}
					}
				}
			}
			if (filemime) {
				let extension = filemime ? mime.extension(filemime) : null;
				let media_file_endpoint = `media/${mid}`;
				return await fetchAs({
					endpoint: media_file_endpoint,
					dispatch,
					headers: {
						"Content-Type": filemime,
					},
					extraParams: { useDefaultJsonApiPath: false, returnResponse: true },
				})
					.then((response) => {
						return !response || response.status !== 200 ? null : response;
					})
					.then((response) => {
						return response ? response.blob() : null;
					})
					.then((blob) => {
						try {
							if (blob) {
								const url = window.URL.createObjectURL(new Blob([blob]));
								const link = document.createElement("a");
								link.href = url;

								link.setAttribute("download", `${file_name}.${extension}`);
								document.body.appendChild(link);
								link.click();
								link.parentNode.removeChild(link);
								return true;
							} else {
								throw new Error("Error transferring file");
							}
						} catch (error) {
							console.error(error.message);
							return false;
						}
					});
			}
		}
	}
	return false;
};
